module.exports = __webpack_public_path__ + "media/logos/roadcc-54171c01.svg";